import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InboxIcon from "@mui/icons-material/Inbox"; // Import an icon
import OrderCard from "./OrderCardComponent/OrderCard";
import { alpha, useTheme } from "@mui/material/styles";

const OrderGrid = ({ orders, onViewDetails, onAcceptOrder, onPrintOrder }) => {
  const theme = useTheme();

  const getEmptyStateStyles = () => {
    return {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
      gap: 2,
      opacity: 0.7,
    };
  };

  const renderEmptyState = () => {
    return (
      <Box sx={getEmptyStateStyles()}>
        <Box
            sx={{
                p: 4,
                bgcolor: alpha(theme.palette.divider, 0.1),
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1
            }}
        >
            <InboxIcon sx={{ fontSize: 64, color: theme.palette.text.secondary }} />
        </Box>
        <Box sx={{ textAlign: "center" }}>
            <Typography variant="h5" color="text.secondary" fontWeight="600" gutterBottom>
              Nenhum pedido por aqui
            </Typography>
            <Typography variant="body1" color="text.disabled">
              Aguardando novos pedidos chegarem...
            </Typography>
        </Box>
      </Box>
    );
  };

  const renderOrderCard = (order) => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3} // Adjusted for better density on large screens
        xl={2}
        key={order.order_id || order.order_index}
      >
        <OrderCard
          order={order}
          onViewDetails={onViewDetails}
          onAcceptOrder={onAcceptOrder}
          onPrintOrder={onPrintOrder}
        />
      </Grid>
    );
  };

  const renderOrderCards = () => {
    return (
      <Grid container spacing={3}>
        {orders.map(renderOrderCard)}
      </Grid>
    );
  };

  const hasOrders = () => {
    return orders && orders.length > 0;
  };

  if (!hasOrders()) {
    return renderEmptyState();
  }

  return renderOrderCards();
};

export default OrderGrid;
